import BaseCollection from "nexia_mobile/models/base_collection";
import LocalSettings from "nexia_mobile/models/local_settings";
import Location from "nexia_mobile/models/location";
import Schema from "nexia_mobile/models/schema";

export default class LocationCollection extends BaseCollection {
  model = Location;
  childSchemaHref = `${LocalSettings.getHost()}/mobile/houses/new`;

  getChildSchema() {
    const schema = new Schema();
    if (this.childSchemaHref == null) {
      return Promise.reject(
        new Error(
          "Cannot get child schema on location collection with no child schema link"
        )
      );
    }
    schema.setUrl(this.childSchemaHref);
    return schema.fetch().then(() => schema);
  }
}



// WEBPACK FOOTER //
// ./src/models/location_collection.js